import produce from 'immer';
import {
  SET_DETAIL_TABLE,
  LOADER_STATUS,
  SET_FILE_DATA,
  SET_OTP_BOX,
  ON_NOTIFY,
  OTP_INVALID,
  SET_FILE_ERROR,
  CHANGE_USERNAME,
  ON_CALL_UPLOAD,
  ON_SUBMIT_TRUE,
  SET_ERR_COUNT,
  SET_PROCESS_COUNT,
  PROFILE_INFO,
  SET_TABLE_DATA,
  SET_HISTORY_DATA,
  TOTAL_RECORD,
  TOTAL_UPLOAD_RECORD
} from './constants';


export const initialState = {
    loaderStatus: false,
    profileData: [],
    fileData: [],
    isOtpActive: false,
    isOtpInvalid: false,
    processVal: '',
    errorVal:'',
    submitStatus:'',
    username:'',
    tabelData:[],
    historyTableData:[],
    status: false,
    msg: '',
    totalRecords: '',
    records: '',
    totalUploadRecords:"",
    uploadRecords:""
  };


  const uploadGstr3bReducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHANGE_USERNAME:
        return {
          ...state,
          username:action.username.replace(/@/gi, '')
        }
        case TOTAL_RECORD:
          return {
            ...state,
            totalRecords:action.totalRecords,
            records:action.records
          }
          case TOTAL_UPLOAD_RECORD:
            return {
              ...state,
              totalUploadRecords: action.totalUploadRecords,
              uploadRecords: action.uploadRecords,
            }
          
      case ON_CALL_UPLOAD:
        return {
          ...state,
          uploadData:action.uploadData
        }
      case ON_SUBMIT_TRUE:
        return {
          ...state,
          submitStatus:action.submitStatus
        }
      case SET_ERR_COUNT:
        return {
          ...state,
          errorVal:action.errorVal
        }
      case SET_PROCESS_COUNT:
        return {
          ...state,
          processVal:action.processVal
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case SET_OTP_BOX:
        return {
          ...state,
          isOtpActive:action.isOtpActive
        }
      case OTP_INVALID:
        return {
          ...state,
          isOtpInvalid:action.isOtpInvalid
        }
      case SET_TABLE_DATA:
        return {
          ...state,
          tabelData:action.tabelData
        }
        case SET_HISTORY_DATA:
          return {
            ...state,
            historyTableData:action.historyTableData
          }
        case ON_NOTIFY:
          return {
            ...state,
            status:action.status,
            msg:action.msg
          }
      default:
        return state;
    }
  };

export default uploadGstr3bReducer;